import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

axiosInstance.interceptors.request.use((config) => {
    if(!config.url.includes('/auth')) {
        config.headers = {
            'Authorization': `Bearer ${window.localStorage.getItem('access_token')}`
        }
    }

    return config
})

axiosInstance.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
  // Do something with response error
    if (error.response.status == 403) {
        axios.get(`${process.env.VUE_APP_API_URL}/auth/logkeluar`)
        window.localStorage.clear();
        location.href = process.env.VUE_APP_INITIAL_URL;
    }
  return Promise.reject(error);
});

export default axiosInstance